import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames'
import _ from 'underscore'
import {Cell} from 'fixed-data-table'

import {SORT_TYPES} from '../constants'

import './HeaderCell.less'

/**
 * A constant, default class for every HeaderCell instance
 * @constant
 * @private
 */
const COMPONENT_CLASS = 'nmc-header-cell'

/**
 * A constant, default extra classes for every HeaderCell instance
 * @constant
 * @private
 */
const COMPONENT_ALIASES = ['nmc-header-cell-container']

/**
 * A constant class for the header if it's sorted
 */
const SORTED_CLASS = 'sorted'

/**
 * A constant class for the header if it's sortable
 */
const SORTABLE_CLASS = 'sortable'

/**
 * A constant classes for the row if it's sorted
 */
const SORT_TYPE_CLASSES = {
  [SORT_TYPES.DESC]: 'sort-desc',
  [SORT_TYPES.ASC]: 'sort-asc'
}

/**
 * Returns the sort icon element
 * @returns {React.Component}
 */
const getSortElement = () => {
  return (
    <span className='sort-icon' />
  )
}

/**
 * @class Components/Table/HeaderCell
 */
class HeaderCell extends React.Component {
  isSorted () {
    return !!this.props.isSorted
  }

  isSortable () {
    return !!this.props.isSortable
  }

  /**
   * Returns the sorted classes
   * @returns {Array<String>}
   */
  getSortingClasses () {
    const classes = []
    /**
     * If this component is sortable
     */
    if (this.isSortable()) {
      classes.push(SORTABLE_CLASS)
      /**
       * If it's also sorted right now
       */
      if (this.isSorted()) {
        classes.push(SORTED_CLASS)
        /**
         * If the sort type is also provided
         */
        if (this.props.sortType) {
          classes.push(SORT_TYPE_CLASSES[this.props.sortType])
        }
      }
    }
    return classes
  }

  /**
   * Returns all the classes
   * @returns {Array<String>}
   */
  getClassNames () {
    return [COMPONENT_CLASS, ...COMPONENT_ALIASES, ...this.getSortingClasses()]
  }

  render () {
    const props = _.omit(this.props, ['name', 'isSortable', 'isSorted', 'sortType', 'onSortClick'])
    return (
      <Cell className={classnames(this.getClassNames())} onClick={this.props.onSortClick} data-value={this.props.value} {...props}>
        <span className='cell-content'>
          <span className='text'>{this.props.name}</span>
          {this.isSortable() ? getSortElement() : ''}
        </span>
      </Cell>
    )
  }
}

HeaderCell.propTypes = {
  name: PropTypes.string,
  isSortable: PropTypes.bool,
  isSorted: PropTypes.bool,
  sortType: PropTypes.string,
  onSortClick: PropTypes.func
}

HeaderCell.defaultProps = {
  isSortable: false
}

export default HeaderCell



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/Table/HeaderCell/index.js